import axios from "@app/Security/AxiosAuthentication";
import ApiEndpoints from "@app/utils/ApiEndpoints";
import PageRouteInterface from "@app/Interface/PageRouteInterface";
import PageRouteModel from "@app/Model/PageRouteModel";
import RollbarHelper from "@app/utils/RollbarHelper";

export default class PageRouteHelper {

    /**
     * Gets all the page routes. Used for generating links on web pages.
     * 
     * @returns 
     */
    static getPageRoutes = async (): Promise<PageRouteInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.PAGE_ROUTES;

        const url = baseUrl + endPoint;

        const options = {
            withCredentials: true
        };

        try {

            const response = await axios.get(url, options);

            if (response.status === 200) {

                const routes: PageRouteInterface[] = [];

                const dataItems: [] = response.data["hydra:member"];

                if (Array.isArray(dataItems)) {

                    dataItems.forEach(item => {

                        // model insures correct data types are created
                        const route = new PageRouteModel(item);

                        routes.push(route);

                    });

                }

                return routes;

            }

        } catch (error) {

            RollbarHelper.logRequestError(error, "getPageRoutes()");

            return [];

        }

        return [];

    }

    /**
     * 
     * @param routes 
     * @param pageId 
     * @returns 
     */
    static getPageRouteByPageId = (routes: PageRouteInterface[], pageId: number): PageRouteInterface => {

        const route = PageRouteHelper.getPageRoute(routes, pageId);

        return route;

    }

    /**
     * 
     * @param routes 
     * @param pageId 
     * @returns 
     */
     static getPageRouteByTemplate = (routes: PageRouteInterface[], templateName: string): PageRouteInterface => {

        const route = PageRouteHelper.getPageRoute(routes, undefined, templateName);

        return route;

    }

    /**
     * 
     * @param routes 
     * @param pageId 
     * @returns 
     */
     static getPageRouteByReportType = (routes: PageRouteInterface[], reportType: string): PageRouteInterface => {

        const route = PageRouteHelper.getPageRoute(routes, undefined, undefined, reportType);

        return route;

    }

    /**
     * 
     * @param routes 
     * @param pageId 
     * @returns 
     */
     static getPageRouteByChartType = (routes: PageRouteInterface[], chartType: string): PageRouteInterface => {

        const route = PageRouteHelper.getPageRoute(routes, undefined, undefined, undefined, chartType);

        return route;

    }

    /**
     * get a page route for a contact us form based on type
     * @param routes 
     * @param pageId 
     * @returns 
     */
     static getPageRouteByContactType = (routes: PageRouteInterface[], contactType: string): PageRouteInterface => {

        const route = PageRouteHelper.getPageRoute(routes, undefined, undefined, undefined, undefined, contactType);

        return route;

    }

    /**
     * Emulating function overloading
     * @param routes 
     * @param pageId      will only search by page id
     * @param template    will only search by template 
     * @param reportType  will only search on report_template and report type 
     * @param chartType   will only search on chart_template and chart type 
     * @param contactType will only search for contact_form_template and contact type
     * @returns 
     */
    static getPageRoute = (routes: PageRouteInterface[], pageId?: number, template?: string, reportType?: string, chartType?: string, contactType?: string): PageRouteInterface => {

        let route: PageRouteInterface | undefined = undefined;

        if (pageId) {

            route = routes.find(route => route.id === pageId);

        } else if (template) {

            route = routes.find(route => route.template.toLowerCase() === template.toLowerCase());

        } else if (reportType) {

            route = routes.find(route => route.reportType.toLowerCase() == reportType.toLowerCase());

        } else if (chartType) {

            route = routes.find(route => route.chartType.toLowerCase() == chartType.toLowerCase());

        } else if (contactType) {
            
            route = routes.find(route => route.contactType.toLowerCase() == contactType.toLowerCase());

        }

        // fall back to an empty model
        if (route === undefined) {
            route = new PageRouteModel();
        }

        return route;

    }
}